export default "__VITE_ASSET__Cum$DmQy__"